import { render, staticRenderFns } from "./SyncImport.vue?vue&type=template&id=2cc002d9&scoped=true"
import script from "./SyncImport.vue?vue&type=script&lang=js"
export * from "./SyncImport.vue?vue&type=script&lang=js"
import style0 from "./SyncImport.vue?vue&type=style&index=0&id=2cc002d9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc002d9",
  null
  
)

export default component.exports